/**
 * Preloads images by creating Image objects.
 * Returns a Promise that resolves when all images are loaded.
 * @param {string[]} srcArray - Array of image URLs to preload
 * @returns {Promise<void>}
 */
export const preloadImages = (srcArray) => {
    if (!srcArray || srcArray.length === 0) return Promise.resolve();

    const promises = srcArray.map((src) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            img.onload = resolve;
            img.onerror = resolve; // Resolve even on error to avoid blocking
        });
    });

    return Promise.all(promises);
};
